import { ISidebarConfig, ISidebarSection } from '../components/sidebar-menu/sidebar-menu.interface';
import { BASE_SIDEBAR_SECTION } from './base.config';
import { GUARD_SIDEBAR_SECTION } from './guard.config';
import { HR_SIDEBAR_SECTION } from './hr.config';

export const ADMIN_SIDEBAR_SECTION: ISidebarSection = {
    id: 'admin',
    title: 'Administração',
    items: [
        {
            id: 'admin-cadastros',
            title: 'Cadastros',
            icon: 'posts',
            isVisible: true,
            children: [
                {
                    id: 'posts',
                    title: 'Postos',
                    route: '/postos',
                    icon: 'users',
                    isVisible: true,
                },
                {
                    id: 'vehicles',
                    title: 'Veículos',
                    route: '/veiculos',
                    icon: 'car',
                    isVisible: true,
                },
                {
                    id: 'registration-links',
                    title: 'Link de Cadastro',
                    route: '/link-cadastro',
                    icon: 'link',
                    isVisible: true,
                },
            ],
        },
    ],
    isVisible: true,
};

export const ADMIN_SIDEBAR_CONFIG: ISidebarConfig = {
    role: 'ADMIN',
    sections: [BASE_SIDEBAR_SECTION, ADMIN_SIDEBAR_SECTION, HR_SIDEBAR_SECTION, GUARD_SIDEBAR_SECTION],
};
